import { useState, useRef, useEffect } from "react";
import "../VideoPopup.css";

const VideoPopup = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [position, setPosition] = useState({ x: 100, y: 70 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const videoRef = useRef(null);

  useEffect(() => {
    if (isExpanded && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.error("Video playback failed:", error);
      });
    }
    
  }, [isExpanded]);

  const handleMouseDown = (e) => {
    setDragging(true);
    setOffset({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseMove = (e) => {
    if (dragging) {
      setPosition({ x: e.clientX - offset.x, y: e.clientY - offset.y });
    }
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`video-popup ${isExpanded ? "expanded" : "collapsed"}`}
      style={{ top: `${position.y}px`, left: `${position.x}px` }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <button
        className="close-button"
        onClick={(e) => {
          e.stopPropagation();
          setIsVisible(false);
        }}
      >
        ✕
      </button>
<div onClick={() => setIsExpanded(true)} className="video-container">
  {!isExpanded && (
    <img
      src="/images/assets/wm.jpg"
      alt="preview"
      className="video-preview"
    />
  )}

  {isExpanded && (
    <video
      ref={videoRef}
      src="https://res.cloudinary.com/dcuturlmb/video/upload/v1776960493/player_export_compressed_qlaukk.mp4"
      className="video-content"
      loop
      muted={false}
      autoPlay
    />
  )}
</div>
    </div>
  );
};

export default VideoPopup;
